/* eslint-disable camelcase */
/* eslint-disable import/no-duplicates */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Link as LinkChakra,
  Skeleton,
  Spinner,
  Stack,
  Table,
  Tbody,
  Td,
  Text,
  Textarea,
  Th,
  Thead,
  Tooltip,
  Tr,
  useBreakpointValue,
  useToast
} from '@chakra-ui/react'
import format from 'date-fns/format'
import ls from 'localstorage-slim'
import { useSubscription } from 'mqtt-react-hooks'
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AiFillLock, AiFillUnlock, AiOutlineWhatsApp } from 'react-icons/ai'
import { FcInfo } from 'react-icons/fc'
import { FiDollarSign, FiEdit, FiEye, FiUser } from 'react-icons/fi'
import { useMutation, useQuery } from 'react-query'
import { Link } from 'react-router-dom'
import { ModalArrivedTime } from '../../components/Modal/confirmArrivedTime'
import { Pagination } from '../../components/PaginationNew'
import { ViewDayTimeline } from '../../components/ReactScheduling'
import { getScheduling, Scheduling as SchedulingType } from '../../hooks/scheduling/useScheduling'
import { LayoutList } from '../../layouts/List'

import { MdSpeakerNotes, MdSpeakerNotesOff } from 'react-icons/md'
import { AttendanceTimeline } from '../../components/AttendanceTimeline'
import { AvailableSlotsCard } from '../../components/AvailableSlotsCard'
import { PatientAvatarPreview } from '../../components/AvatarScheduling'
import { BlockTimesModal } from '../../components/BlockTimesModal'
import InfoTooltipCard from '../../components/Cards/tooltipCard'
import { Select } from '../../components/Form/Select'
import { TextFieldControlled } from '../../components/Form/TextFieldControlled'
import { ModalConfirmExclude } from '../../components/Modal/confirmExclude'
import { NotFound } from '../../components/molecules/NotFound'
import { MultiSelectMenuFilter } from '../../components/MultiSelectFilters'
import { NotesModal } from '../../components/NotesModal'
import { PermissionComponent } from '../../components/Permissions'
import { ServiceProtocolTooltip } from '../../components/ServiceProtocolTooltip'
import { useAuth } from '../../hooks/auth'
import { NotesData } from '../../hooks/notes/useNotes'
import { BlocksData } from '../../hooks/scheduling/useScheduling'
import { useSchedulingTimeline } from '../../hooks/scheduling/useSchedulingTimeline'
import { useModal } from '../../hooks/useModal'
import { queryClient } from '../../services/reactQuery'
import { handlerExportXlsx } from '../../utils/fns/exportXlsx'
import { remaskCaractersAll } from '../../utils/fns/removeCaracters'
import { formatDateBRFull, formatHour, toUtcFromClinic } from '../../utils/timezone'
import { useService } from './service'

// debounce
let timer: any = null

// language
type Language = 'pt' | 'en' | 'es'

type ActionsWs =
  | 'cancel-attendance'
  | 'finish-attendance'
  | 'allow-start-attendance'
  | 'logout-user'
  | undefined

// debounce update call
let timerUpdate: any = null

interface ServiceData {
  id: number
  service_id: number
  service_name: string
}

interface Mutation {
  payload: object
  id: string
}

export function Scheduling() {
  const { decodeToken, isSpecialist } = useAuth()
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  })

  // context work filters
  const {
    setStatusParam,
    setSpecialistIds,
    specialistIds,
    statusParam,
    dateScheduling,
    setDateScheduling,
    LocaleApp,
    setTabIndexClient,
    searchDefaultScheduling,
    setSearchDefaultScheduling,
    isLoginSpecialistIsDefault,
    setIsLoginSpecialistIsDefault
  } = useModal()
  console.log(statusParam, 'statusParam')
  const services = useService()
  const toast = useToast()
  const [t] = useTranslation('pageScheduling')
  const skeletonRepeat = [1, 2, 3, 4, 5, 6, 7]
  // mutation
  const updateAttendance = useMutation(
    async ({ payload, id }: Mutation) => {
      await services.handlerUpdateAttendance(payload, id)
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries('scheduling')
      },
      onSuccess: (data) => {
        queryClient.invalidateQueries('scheduling')
      },
      onError: () => {
        // Invalidate Cache
        queryClient.invalidateQueries('scheduling')

        // Message error
        toast({
          title: 'Cadastro não realizado',
          description: 'Ouve um erro de comunicação com o servidor',
          status: 'error',
          isClosable: true,
          duration: 3000,
          position: 'top'
        })
      }
    }
  )
  // state control bar
  // specialist state control filter
  const [startAt, setStartAt] = useState(`${dateScheduling}T00:00`)
  const [endAt, setEndAt] = useState(`${dateScheduling}T23:59`)
  const [currentPage, setCurrentPage] = useState(1)
  const [isActive, setIsActive] = useState(true)
  // control state front-end model
  const [frontendModel, setFrontendModel] = useState(0)
  // style button selected
  const selectedButton = {
    border: '1px solid #031f35',
    background: '#fff',
    color: '#000'
  }
  const statusOptionsLimited = [
    { value: 1, label: `${t('status.1')}` },
    { value: 2, label: `${t('status.2')}` },
    { value: 3, label: `${t('status.3')}` }
  ]
  const statusOptionsDefault = [
    { value: 1, label: `${t('status.1')}` },
    { value: 2, label: `${t('status.2')}` },
    { value: 3, label: `${t('status.3')}` },
    { value: 4, label: `${t('status.4')}` },
    { value: 5, label: `${t('status.5')}` }
  ]
  const statusOptionsDocument = [
    { value: 1, label: `${t('status.1')}` },
    { value: 2, label: `${t('status.2')}` },
    { value: 3, label: `${t('status.3')}` },
    { value: 4, label: `${t('status.4')}` },
    { value: 5, label: `${t('status.5')}` },
    { value: 6, label: `${t('status.6')}` },
    { value: 7, label: `${t('status.7')}` }
  ]
  // status change state value for back end
  const [status, setStatus] = useState<number | null>(null)
  const [isChangeStatus, setIsChangeStatus] = useState(false)
  const [selectedScheduling, setSelectedScheduling] = useState<SchedulingType | null>(null)
  const [arrivedTime, setArrivedTime] = useState('')
  const exactHours = new Date().getHours()
  const exactMinutes = new Date().getMinutes()
  // modal input hours arrivedTime
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenExclude, setIsOpenExclude] = useState(false)
  // modal message whatsApp
  const [message, setMessage] = useState('')
  const [numberWhatsApp, setNumberWhatsApp] = useState('')
  const [isOpenWhatsApp, setIsOpenWhatsApp] = useState(false)
  const [statusLocal, setStatusLocal] = useState<any>(statusParam)
  const [specialistLocal, setSpecialistLocal] = useState(specialistIds)
  const [isButtonFilters, setIsButtonFilters] = useState(false)
  const [isViewModalNote, setIsViewModalNote] = useState(false)
  const [notes, setNotes] = useState<NotesData[]>([])
  const [patientName, setPatientName] = useState('')
  const [patientId, setPatientId] = useState(0)

  const [isViewBlockModal, setIsViewBlockModal] = useState(false)
  const [selectedBlock, setSelectedBlock] = useState<BlocksData | null>(null)

  const allowedTimelineStatus = new Set(['1', '2', '5', '6', '7'])

  const hasStatusParamFilter =
    Array.isArray(statusParam) &&
    statusParam.length > 0 &&
    statusParam.every((id) => allowedTimelineStatus.has(String(id)))

  const hasSpecialistFilter = Array.isArray(specialistIds) && specialistIds.length === 1

  const isTimelineView = hasStatusParamFilter && hasSpecialistFilter

  const isScheduling = (data: SchedulingType | BlocksData): data is SchedulingType => {
    return (
      data &&
      'guide' in data &&
      'patient_id' in data &&
      'scheduled_initial_time' in data &&
      'scheduled_final_time' in data &&
      'attendance_items' in data
    )
  }

  const isAppointmentItem = (item: {
    type: string
    data: SchedulingType | BlocksData
  }): item is {
    type: 'appointment'
    data: SchedulingType
  } => {
    return item.type === 'appointment' && isScheduling(item.data)
  }

  const isBlockItem = (item: {
    type: string
    data: SchedulingType | BlocksData
  }): item is {
    type: 'block'
    data: BlocksData
  } => {
    return item.type === 'block' && !isScheduling(item.data)
  }

  // helpers
  const weekDayMap: Record<string, string> = {
    '1': 'Seg',
    '2': 'Ter',
    '3': 'Qua',
    '4': 'Qui',
    '5': 'Sex',
    '6': 'Sáb',
    '7': 'Dom'
  }

  const statusNames: Record<number, string> = {
    1: t('status.1'),
    2: t('status.2'),
    3: t('status.3'),
    4: t('status.4'),
    5: t('status.5'),
    6: t('status.6'),
    7: t('status.7')
  }

  const getStatusName = (status: number | null) => {
    if (!status) return '—'

    return statusNames[status]
  }

  const formatBlockWeekDays = (weekDay?: string | null) => {
    if (!weekDay) return '—'

    return weekDay
      .split(',')
      .map((item) => weekDayMap[item.trim()] || item.trim())
      .join(', ')
  }

  const formatBlockTimeRange = (block: BlocksData, mode?: 'start' | 'finish') => {
    if (block.start_time && block.finish_time) {
      if (mode === 'start') {
        return `${formatHour(block.start_time, decodeToken.clinic.timezone)}`
      }

      if (mode === 'finish') {
        return `${formatHour(block.finish_time, decodeToken.clinic.timezone)}`
      }

      return `${formatHour(block.start_time, decodeToken.clinic.timezone)} às ${formatHour(
        block.finish_time,
        decodeToken.clinic.timezone
      )}`
    }

    if (block.recurrent_start_time && block.recurrent_finish_time) {
      if (mode === 'start') {
        return `${block.recurrent_start_time.substring(0, 5)}`
      }

      if (mode === 'finish') {
        return `${block.recurrent_finish_time.substring(0, 5)}`
      }

      return `${block.recurrent_start_time.substring(
        0,
        5
      )} às ${block.recurrent_finish_time.substring(0, 5)}`
    }

    return '—'
  }

  const formatBlockSpecialists = (block: BlocksData) => {
    if (!block.specialists?.length) return '—'

    return block.specialists
      .map((specialist) => specialist.social_name || specialist.name)
      .join(', ')
  }

  useEffect(() => {
    if (isLoginSpecialistIsDefault === false) {
      if (isSpecialist === true) {
        setSpecialistLocal([String(decodeToken?.user_id)])
        setSpecialistIds([String(decodeToken?.user_id)])
      } else {
        setSpecialistIds(specialistIds)
      }

      setIsLoginSpecialistIsDefault(true)
    }

    return () => {}
  }, [isSpecialist])

  const {
    data: getSchedulingData,
    refetch,
    isLoading,
    isFetching
  } = useQuery(
    [
      'scheduling',
      currentPage,
      searchDefaultScheduling,
      startAt,
      endAt,
      specialistIds,
      statusParam,
      isActive,
      frontendModel
    ],
    () =>
      getScheduling(
        currentPage,
        searchDefaultScheduling,
        startAt,
        endAt,
        specialistIds,
        statusParam,
        isActive,
        frontendModel
      )
  )

  const mergedData = useSchedulingTimeline(
    getSchedulingData?.scheduling || [],
    getSchedulingData?.blocks || [],
    dateScheduling
  )

  useEffect(() => {
    const verifyFilterApply = () => {
      let isDifferent = false

      if (specialistIds !== specialistLocal) {
        isDifferent = true
      }

      if (statusLocal !== statusParam) {
        isDifferent = true
      }

      return isDifferent
    }

    setIsButtonFilters(verifyFilterApply)
  }, [specialistLocal, statusLocal])

  // apply filters
  const handlerApplyFilters = () => {
    setSpecialistIds(specialistLocal)
    setStatusParam(statusLocal)
  }

  // update date Scheduling
  const updateDataScheduling = async () => {
    refetch()
    setIsChangeStatus(false)
    setStatus(null)
    setSelectedScheduling(null)
    setArrivedTime('')
  }

  // return exact hours
  const formatAndReturnExactHours = () => {
    const [hoursLeft, hoursRight] = String(exactHours).padStart(2, '0').split('')
    const [minutesLeft, minutesRight] = String(exactMinutes).padStart(2, '0').split('')

    return `${hoursLeft}${hoursRight}:${minutesLeft}${minutesRight}`
  }

  // handler Change status for scheduling by index

  const handlerUpdateStatusScheduling = async (
    value: number | null,
    schedulingItem: SchedulingType | null
  ) => {
    if (!schedulingItem) {
      return
    }

    if (value === 5) {
      const exactTime = formatAndReturnExactHours()
      setArrivedTime(exactTime)
      setIsOpen(true)
      return
    }

    if (value === 3 || value === 4) {
      setIsOpenExclude(true)
      return
    }

    const id = String(schedulingItem.id)

    if (!id) {
      return
    }

    const payload = {
      attendance_spot: schedulingItem.attendance_spot,
      block_guide: schedulingItem.block_guide,
      guide: schedulingItem.guide,
      id,
      invoice_date: schedulingItem.invoice_date,
      invoice_number: schedulingItem.invoice_number,
      is_active: schedulingItem.is_active,
      observation: schedulingItem.observation,
      observation_payment: schedulingItem.observation_payment,
      patient_id: schedulingItem.patient_id,
      real_arrival_time: null,
      real_final_time: schedulingItem.real_final_time,
      real_initial_time: schedulingItem.real_initial_time,
      scheduled_arrival_time: schedulingItem.scheduled_arrival_time,
      scheduled_final_time: schedulingItem.scheduled_final_time,
      scheduled_initial_time: schedulingItem.scheduled_initial_time,
      professional_id: schedulingItem.professional_id,
      status: value,
      attendance_items: schedulingItem.attendance_items,
      value_to_income: schedulingItem.value_to_income,
      indications: schedulingItem.indications ?? [],
      sessions: schedulingItem.sessions ?? [],
      sessions_not_performed: schedulingItem.sessions_not_performed ?? [],
    }

    await updateAttendance.mutateAsync({ payload, id })

    setIsChangeStatus(true)
    updateDataScheduling()
  }

  const { mutate } = useMutation(() => handlerUpdateStatusScheduling(status, selectedScheduling), {
    onSuccess: () => {
      queryClient.invalidateQueries('scheduling')
    }
  })

  const generateArrayMqttObserver = () => {
    if (getSchedulingData?.scheduling !== undefined) {
      if (getSchedulingData?.scheduling !== null) {
        const allArrayAllow = getSchedulingData?.scheduling?.map((item: any) => {
          return `/attendances/${item.hash}/allow-start-attendance/`
        })
        const allArrayFinish = getSchedulingData?.scheduling.map((item) => {
          return `/attendances/${item.hash}/finish-attendance/`
        })

        const allArrayCancel = getSchedulingData?.scheduling?.map((item) => {
          return `/attendances/${item.hash}/cancel-attendance/`
        })

        const allArray = [...allArrayFinish, ...allArrayAllow, ...allArrayCancel]

        return allArray
      }
    }

    return []
  }

  // websocket mqtt listen
  const { message: clientMessage } = useSubscription(generateArrayMqttObserver())

  // return hours format
  const hoursFormat = (myDate: string) => {
    if (myDate === null) {
      return ''
    }

    const formatDate = myDate?.substring(11, 16) ?? ''
    return formatDate
  }

  // return string for xls document
  const ArrayToString = (list: Array<ServiceData>) => {
    const ArrayString = list?.map((item) => {
      return item?.service_name
    })

    const stringArrayGenerator = ArrayString?.join(',')
    const resultString = stringArrayGenerator?.replaceAll(',', '\n')

    return resultString
  }

  // maker document planilhe
  const exportOject = getSchedulingData?.scheduling?.map((item) => {
    const language = ls.get<Language>('@CLINIC:LANGUAGE_DEFAULT')
    const servicesStringValue = ArrayToString(item?.attendance_items)

    switch (language) {
      case 'en':
        return {
          Guide: item?.guide,
          Date: format(new Date(item?.scheduled_initial_time), 'dd/MM/yyyy'),
          Scheduling: hoursFormat(item?.scheduled_initial_time),
          Arrived: hoursFormat(item?.real_arrival_time),
          Attendance: hoursFormat(item?.scheduled_final_time),
          Status: statusOptionsDocument[item?.status - 1]?.label,
          Client: item?.patient_name,
          Specialist: item?.specialist_name,
          Services: servicesStringValue
        }

      case 'es':
        return {
          Guide: item?.guide,
          Date: format(new Date(item?.scheduled_initial_time), 'dd/MM/yyyy'),
          Scheduling: hoursFormat(item?.scheduled_initial_time),
          Arrived: hoursFormat(item?.real_arrival_time),
          Attendance: hoursFormat(item?.scheduled_final_time),
          Status: statusOptionsDocument[item?.status - 1]?.label,
          Client: item?.patient_name,
          Specialist: item?.specialist_name,
          Services: servicesStringValue
        }

      default:
        return {
          Guia: item?.guide,
          Data: format(new Date(item?.scheduled_initial_time), 'dd/MM/yyyy'),
          Agendado: hoursFormat(item?.scheduled_initial_time),
          Chegou: hoursFormat(item?.real_arrival_time),
          Atendimento: hoursFormat(item?.scheduled_final_time),
          Status: statusOptionsDocument[item?.status - 1]?.label,
          Cliente: item?.patient_name,
          Especialista: item?.specialist_name,
          Serviços: servicesStringValue
        }
    }
  })

  const handlerGeneratedExcel = () => {
    if (frontendModel === 0) {
      handlerExportXlsx(exportOject, t('title'), dateScheduling)
    } else {
      handlerExportXlsx(exportOject, t('title'))
    }
  }

  const SearchInputCallbackValue = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget

    clearTimeout(timer)

    timer = setTimeout(() => {
      setCurrentPage(1)
      setSearchDefaultScheduling(value)
    }, 500)
  }, [])

  const ActiveCheckboxCallbackValue = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(event.target.checked)
  }, [])

  // button next day
  const handlerClickButtonNextDay = () => {
    // get date
    const day = Number(dateScheduling.substring(8, 10))
    const month = Number(dateScheduling.substring(5, 7)) - 1
    const year = Number(dateScheduling.substring(0, 4))
    const nowDate = new Date(year, month, day)
    const tomorrow = format(nowDate.setDate(nowDate.getDate() + 1), 'yyyy-MM-dd')
    setDateScheduling(tomorrow)
  }

  // button back day
  const handlerClickButtonBackDay = () => {
    // get date
    const day = Number(dateScheduling.substring(8, 10))
    const month = Number(dateScheduling.substring(5, 7)) - 1
    const year = Number(dateScheduling.substring(0, 4))
    const nowDate = new Date(year, month, day)
    const backDay = format(nowDate.setDate(nowDate.getDate() - 1), 'yyyy-MM-dd')
    setDateScheduling(backDay)
  }
  // validation hours Arrived Time input
  const validationHoursArrivedTime = () => {
    let validationReturn = false
    const hour = arrivedTime

    if (hour.length !== 5) {
      validationReturn = true
    }

    if (hour.length === 5) {
      const hoursRemask = remaskCaractersAll(hour)
      const minutes = hoursRemask.substring(2, 4)

      if (Number(hoursRemask) > 2359) {
        validationReturn = true
      }

      if (Number(minutes) > 59) {
        validationReturn = true
      }
    }

    return validationReturn
  }

  // handler Close modal Arrived time
  const handlerCloseModalArrivedTime = () => {
    setIsOpen(false)
    setArrivedTime('')
  }

  // handler Change status for Status Arrived Time
  const handlerUpdateStatusAndArrivedTime = async (
    value: number | null,
    schedulingItem: SchedulingType | null
  ) => {
    if (!schedulingItem) {
      return
    }

    const id = String(schedulingItem.id)

    if (!id) {
      return
    }

    const dateNow = format(new Date(), 'yyyy-MM-dd')
    const time = toUtcFromClinic(dateNow, arrivedTime, decodeToken.clinic.timezone)

    const payload = {
      attendance_spot: schedulingItem.attendance_spot,
      block_guide: schedulingItem.block_guide,
      guide: schedulingItem.guide,
      id,
      invoice_date: schedulingItem.invoice_date,
      invoice_number: schedulingItem.invoice_number,
      is_active: schedulingItem.is_active,
      observation: schedulingItem.observation,
      observation_payment: schedulingItem.observation_payment,
      patient_id: schedulingItem.patient_id,
      real_arrival_time: time,
      real_final_time: schedulingItem.real_final_time,
      real_initial_time: schedulingItem.real_initial_time,
      scheduled_arrival_time: schedulingItem.scheduled_arrival_time,
      scheduled_final_time: schedulingItem.scheduled_final_time,
      scheduled_initial_time: schedulingItem.scheduled_initial_time,
      attendance_items: schedulingItem.attendance_items,
      professional_id: schedulingItem.professional_id,
      status: value,
      value_to_income: schedulingItem.value_to_income,
      indications: schedulingItem.indications ?? [],
      sessions: schedulingItem.sessions ?? [],
      sessions_not_performed: schedulingItem.sessions_not_performed ?? [],
    }

    if (arrivedTime === '') {
      toast({
        title: 'Aconteceu um error!',
        description: `O horário é obrigatório`,
        status: 'error',
        isClosable: true,
        duration: 3000,
        position: 'top-right'
      })

      return
    }

    const validateHours = validationHoursArrivedTime()

    if (validateHours === true) {
      toast({
        title: 'Aconteceu um error!',
        description: `O horário informado é invalido`,
        status: 'error',
        isClosable: true,
        duration: 3000,
        position: 'top-right'
      })

      return
    }

    await updateAttendance.mutateAsync({ payload, id })
    handlerCloseModalArrivedTime()
    await updateDataScheduling()
  }

  // handler Change status for Status Cancel or not presence 3 or 4
  const handleChangeStatusCancelOrNotPresence = async (
    value: number | null,
    schedulingItem: SchedulingType | null
  ) => {
    if (!schedulingItem) {
      return
    }

    const id = String(schedulingItem.id)

    if (!id) {
      return
    }

    const payload = {
      attendance_spot: schedulingItem.attendance_spot,
      block_guide: schedulingItem.block_guide,
      guide: schedulingItem.guide,
      id,
      invoice_date: schedulingItem.invoice_date,
      invoice_number: schedulingItem.invoice_number,
      is_active: schedulingItem.is_active,
      observation: schedulingItem.observation,
      observation_payment: schedulingItem.observation_payment,
      patient_id: schedulingItem.patient_id,
      real_arrival_time: schedulingItem.real_arrival_time,
      real_final_time: schedulingItem.real_final_time,
      real_initial_time: schedulingItem.real_initial_time,
      scheduled_arrival_time: schedulingItem.scheduled_arrival_time,
      scheduled_final_time: schedulingItem.scheduled_final_time,
      scheduled_initial_time: schedulingItem.scheduled_initial_time,
      attendance_items: schedulingItem.attendance_items,
      professional_id: schedulingItem.professional_id,
      status: value,
      value_to_income: schedulingItem.value_to_income,
      indications: schedulingItem.indications ?? [],
      sessions: schedulingItem.sessions ?? [],
      sessions_not_performed: schedulingItem.sessions_not_performed ?? [],
    }

    await updateAttendance.mutateAsync({ payload, id })
    await updateDataScheduling()
    toast({
      title: 'Sucesso!',
      description: `Agendamento atualizado com sucesso`,
      status: 'success',
      isClosable: true,
      duration: 3000,
      position: 'top-right'
    })
    setIsOpenExclude(false)
  }

  // get filters specialist
  const getFiltersSpecialist = (values: String[] | String) => {
    setSpecialistLocal(values)
  }

  // websocket receive message
  useEffect(() => {
    const topic = clientMessage?.topic.split('/')
    const hash = topic?.[2]
    const action = topic?.[1]

    switch (action as ActionsWs) {
      case 'allow-start-attendance':
        queryClient.invalidateQueries('scheduling')
        refetch()
        break
      case 'cancel-attendance':
        queryClient.invalidateQueries('scheduling')
        refetch()

        break
      case 'finish-attendance':
        queryClient.invalidateQueries('scheduling')
        refetch()

        break
      default:
        break
    }
  }, [clientMessage])

  // effect update Status Scheduling
  useEffect(() => {
    if (status === null) {
      return
    }

    if (selectedScheduling === null) {
      return
    }

    clearTimeout(timerUpdate)

    timerUpdate = setTimeout(() => {
      mutate()
      if (status !== 5) {
        setIsChangeStatus(true)
      }
    }, 10)
  }, [status, selectedScheduling])

  // message whatsApp functions
  const handleCloseModalWhatsApp = () => {
    setIsOpenWhatsApp(false)
    setMessage('')
  }

  const capitalizeFirst = (str: string | null) => {
    if (!str) return str
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  }

  const capitalizeWords = (str: string | null) => {
    if (!str) return str
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  /**
   * Codifica uma mensagem para o formato correto de URL do WhatsApp
   * - Quebras de linha (\n) → %0A
   * - Espaços → %20
   * - Caracteres especiais → codificação URI
   */
  const encodeWhatsAppMessage = (message: string): string => {
    return encodeURIComponent(message).replace(/%0A/g, '%0A').replace(/%20/g, '%20')
  }

  // Função auxiliar para gerar URL do WhatsApp
  const getWhatsAppUrl = (phone: string, msg: string): string => {
    const encodedMessage = encodeWhatsAppMessage(msg)
    return `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`
  }

  const handleOpenDialogWhatsApp = (dataClientScheduling: SchedulingType) => {
    let client: string | null = ''
    if (dataClientScheduling?.patient_social_name) {
      client = dataClientScheduling?.patient_social_name
    } else {
      client = dataClientScheduling?.patient_name
    }

    const hoursMessage = formatHour(
      dataClientScheduling.scheduled_arrival_time,
      decodeToken?.clinic?.timezone
    )
    const dateFormatted = formatDateBRFull(
      dataClientScheduling.scheduled_arrival_time,
      decodeToken?.clinic?.timezone
    )
    const numberPhone = remaskCaractersAll(dataClientScheduling.patient_number ?? '')
    const formatMessage = `🔆 Olá, ${capitalizeWords(client)} 🔆

  ✨ ${capitalizeWords(decodeToken?.clinic?.name)} relembra o seu agendamento.

  👉 ${capitalizeFirst(dateFormatted)}
  🕙 às ${hoursMessage}

  Aguardamos por si. 🙂`

    setMessage(formatMessage)
    setNumberWhatsApp(numberPhone)
    setIsOpenWhatsApp(true)
  }

  const handleOpenDialogWhatsAppConfirm = (dataClientScheduling: SchedulingType) => {
    let client: string | null = ''
    if (dataClientScheduling?.patient_social_name) {
      client = dataClientScheduling?.patient_social_name
    } else {
      client = dataClientScheduling?.patient_name
    }

    const hoursMessage = formatHour(
      dataClientScheduling.scheduled_arrival_time,
      decodeToken?.clinic?.timezone
    )
    const dateFormatted = formatDateBRFull(
      dataClientScheduling.scheduled_arrival_time,
      decodeToken?.clinic?.timezone
    )
    const numberPhone = remaskCaractersAll(dataClientScheduling.patient_number ?? '')
    const formatMessage = `Pronto!🙂

✅ O seu agendamento está marcado, ${capitalizeWords(
      client
    )}, para ${dateFormatted}, às ${hoursMessage}.

⏰ Este horário marcado já contempla o tempo para registos e eventuais preparações. Assim, basta chegar à hora marcada.

📱 Pedimos, por favor, que guarde o nosso número no seu telemóvel, pois enviaremos informações importantes por aqui, através do WhatsApp.

❗ Agradecemos o preenchimento, com a maior brevidade possível, deste questionário. Ele contribui para um atendimento mais seguro e adequado às suas necessidades. O preenchimento demora apenas alguns minutos. Caso já o tenha preenchido nos últimos 12 meses, não é necessário fazê-lo novamente.

https://forms.gle/pGcoyAK7qLXKAGmk9

📍 Morada da Sky Clinic Lisboa:
Rua Hermano Neves 22A, rés-do-chão, Telheiras, 1600-477, Lisboa.

Clique no link abaixo para abrir no Google Maps:
https://maps.app.goo.gl/QZLCpagenL1y7C4U9

🆕 Para acompanhar as novidades da clínica, siga-nos no Instagram:
https://www.instagram.com/danielagorgulho.dermatologista/

Desejamos-lhe um ótimo dia! 🌻`

    setMessage(formatMessage)
    setNumberWhatsApp(numberPhone)
    setIsOpenWhatsApp(true)
  }

  const handleOpenDialogWhatsAppCancel = (dataClientScheduling: SchedulingType) => {
    let client: string | null = ''
    if (dataClientScheduling?.patient_social_name) {
      client = dataClientScheduling?.patient_social_name
    } else {
      client = dataClientScheduling?.patient_name
    }

    const hoursMessage = formatHour(
      dataClientScheduling.scheduled_arrival_time,
      decodeToken?.clinic?.timezone
    )
    const dateFormatted = formatDateBRFull(
      dataClientScheduling.scheduled_arrival_time,
      decodeToken?.clinic?.timezone
    )
    const numberPhone = remaskCaractersAll(dataClientScheduling.patient_number ?? '')
    const formatMessage = `Olá, ${capitalizeWords(client)}! 👋

Lamentamos informar que o seu agendamento para ${dateFormatted} às ${hoursMessage} foi cancelado.

Se desejar reagendar, por favor, entre em contato connosco pelo WhatsApp ou pelo telefone.

Obrigado pela compreensão. 🙂`

    setMessage(formatMessage)
    setNumberWhatsApp(numberPhone)
    setIsOpenWhatsApp(true)
  }

  // effect update dateParam start and end
  useEffect(() => {
    if (frontendModel === 0) {
      setStartAt(`${dateScheduling}T00:00`)
      setEndAt(`${dateScheduling}T23:59`)
    }

    return () => {}
  }, [frontendModel, dateScheduling])

  useEffect(() => {
    refetch()
  }, [])

  // jxs status item ticket
  const returnJsxElementStatusTicket = (statusPayment: number | null | undefined) => {
    if (statusPayment === 1) {
      return (
        <Tooltip label="Checkout" aria-label="checkout" hasArrow placement="top-start">
          <Box w="24px">
            <FiDollarSign color="#c71717f4" size={16} style={{ cursor: 'pointer' }} />
          </Box>
        </Tooltip>
      )
    }

    if (statusPayment === 2) {
      return (
        <Tooltip label="Checkout" aria-label="checkout" hasArrow placement="top-start">
          <Box w="24px">
            <FiDollarSign color="#56c20ff4" size={16} style={{ cursor: 'pointer' }} />
          </Box>
        </Tooltip>
      )
    }

    if (statusPayment === 3) {
      return (
        <Tooltip label="Checkout" aria-label="checkout" hasArrow placement="top-start">
          <Box w="24px">
            <FiDollarSign color="#fd7011f0" size={16} style={{ cursor: 'pointer' }} />
          </Box>
        </Tooltip>
      )
    }

    if (statusPayment === 4) {
      return (
        <Tooltip label="Checkout" aria-label="checkout" hasArrow placement="top-start">
          <Box w="24px">
            <FiDollarSign color="#192facdc" size={16} style={{ cursor: 'pointer' }} />
          </Box>
        </Tooltip>
      )
    }

    if (statusPayment === 5) {
      return null
    }

    return (
      <Tooltip label="Checkout" aria-label="checkout" hasArrow placement="top-start">
        <Box w="24px">
          <FiDollarSign color="#9699B0" size={16} style={{ cursor: 'pointer' }} />
        </Box>
      </Tooltip>
    )
  }

  const returnColorStatusByView = (numberStatus: number) => {
    switch (numberStatus) {
      case 1:
        return '#9699B0'
      case 2:
        return '#5891e6'
      case 3:
        return '#fd7011f0'
      case 4:
        return '#c71717f4'
      case 5:
        return '#192facdc'
      case 6:
        return '#56c20ff4'
      case 7:
        return '#36770a'

      default:
        return '#9699B0'
    }
  }

  return (
    <>
      <LayoutList
        title={t('title')}
        urlNew="/scheduling/create"
        placeholder={t('placeholder.search')}
        isFetching={isFetching}
        refetch={refetch}
        capturaChange={(event: any) => SearchInputCallbackValue(event)}
        captureActiveChange={(event: any) => ActiveCheckboxCallbackValue(event)}
        ignorePermissions
        defaultSearch={searchDefaultScheduling}
        generateExcel={handlerGeneratedExcel}
        isHaveData={getSchedulingData?.scheduling && getSchedulingData?.scheduling.length > 0}
      >
        <>
          <Flex mx="auto" w="100%" direction="row" mb="2" p="4" justify="space-around">
            <Flex w="35%" justify="flex-start" align="end">
              {services.isLoadingSpecialists ? (
                <Spinner color="blue" />
              ) : (
                <HStack spacing={6}>
                  <MultiSelectMenuFilter
                    label="Especialistas"
                    options={services.specialists.map((specialist) => {
                      return {
                        id: String(specialist?.user?.id),
                        name: specialist?.social_name ?? specialist.user.name
                      }
                    })}
                    backChange={(values) => {
                      getFiltersSpecialist(values)
                    }}
                    render={() => {
                      const specialistsRender: any = specialistIds
                      return specialistsRender
                    }}
                  />

                  <MultiSelectMenuFilter
                    label="Status"
                    options={statusOptionsDocument?.map((itemStatus) => {
                      return {
                        id: String(itemStatus.value),
                        name: itemStatus.label
                      }
                    })}
                    backChange={(values) => {
                      setStatusLocal(values)
                    }}
                    render={() => {
                      const statusRender: any = statusParam
                      return statusRender
                    }}
                  />

                  {isButtonFilters && (
                    <Button bg="blue.300" color="white" onClick={() => handlerApplyFilters()}>
                      Aplicar
                    </Button>
                  )}
                </HStack>
              )}
            </Flex>
            {frontendModel === 0 ? (
              <Flex align="end" px="2" mx="2">
                <Flex p="2px" mx="2" w="180px">
                  <Text fontSize={isWideVersion ? '20px' : '14px'} fontWeight="hairline">
                    {format(
                      new Date(
                        Number(dateScheduling?.substring(0, 4)),
                        Number(dateScheduling?.substring(5, 7)) - 1,
                        Number(dateScheduling?.substring(8, 10))
                      ),
                      'EEEE',
                      {
                        locale: LocaleApp
                      }
                    )}
                  </Text>
                </Flex>
                <Button bg="transparent" onClick={() => handlerClickButtonBackDay()} size="sm">
                  <ChevronLeftIcon w={5} h={5} />
                </Button>
                <Flex mx="8px" align="baseline" justify="baseline">
                  <TextFieldControlled
                    textAlign="center"
                    type="date"
                    value={dateScheduling}
                    onChange={(event) => setDateScheduling(event.target.value)}
                    name="date"
                  />
                </Flex>
                <Button bg="transparent" onClick={() => handlerClickButtonNextDay()} size="sm">
                  <ChevronRightIcon w={5} h={5} />
                </Button>
              </Flex>
            ) : null}
            <Flex mx="2" justify="space-around">
              <Flex mr="2" align="end" justify="space-around">
                <Button
                  mr="2"
                  bg="blue.300"
                  color="white"
                  onClick={() => setFrontendModel(0)}
                  _hover={{ background: '#215B88' }}
                  style={frontendModel === 0 ? selectedButton : undefined}
                  size="sm"
                >
                  {t('controlBar.btn1')}
                </Button>
                <Button
                  mr="2"
                  bg="blue.300"
                  color="white"
                  onClick={() => setFrontendModel(1)}
                  _hover={{ background: '#215B88' }}
                  style={frontendModel === 1 ? selectedButton : undefined}
                  size="sm"
                >
                  {t('controlBar.btn2')}
                </Button>
                <AvailableSlotsCard />
              </Flex>
            </Flex>
          </Flex>
          {frontendModel === 0 && (
            <>
              {isTimelineView && (
                <AttendanceTimeline
                  attendances={mergedData?.filter(isAppointmentItem).map((item) => item.data) ?? []}
                  blocks={mergedData?.filter(isBlockItem).map((item) => item.data) ?? []}
                  timeZone={decodeToken?.clinic?.timezone || 'Europe/Lisbon'}
                  title="Timeline do dia"
                />
              )}
              <Box>
                <Table variant="striped" colorScheme="blue" size="sm">
                  <Thead>
                    <Tr>
                      <Th>{t('t1')}</Th>
                      <Th>{t('t2')}</Th>
                      <Th>{t('t3')}</Th>
                      <Th>{t('t4')}</Th>
                      <Th>{t('t5')}</Th>
                      <Th>{t('t6')}</Th>
                      {/* <Th>{t('t7')}</Th> */}
                      {specialistIds.length === 1 ? null : <Th>{t('t8')}</Th>}
                      <Th>{t('t9')}</Th>
                      <Th>{t('t10')}</Th>
                      <Th>{t('t11')}</Th>
                      <Th>{t('t12')}</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {isLoading && (
                      <>
                        {skeletonRepeat?.map((skeleton) => (
                          <Tr key={skeleton}>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                            <Td>
                              <Skeleton height="20px" />
                            </Td>
                          </Tr>
                        ))}
                      </>
                    )}
                    {!isLoading && (
                      <>
                        {mergedData?.map((timelineItem, index: number) => {
                          if (timelineItem.type === 'appointment') {
                            const item = timelineItem.data
                            return (
                              <Tr key={item.id}>
                                <Td>
                                  <Text fontSize="sm">{item.guide}</Text>
                                </Td>
                                <Td>
                                  <Text fontSize="sm">
                                    {formatHour(
                                      item?.scheduled_arrival_time,
                                      decodeToken.clinic.timezone
                                    )}
                                  </Text>
                                </Td>
                                <Td>
                                  <Text fontSize="sm">
                                    {formatHour(
                                      item?.real_arrival_time,
                                      decodeToken.clinic.timezone
                                    )}
                                  </Text>
                                </Td>
                                <Td>
                                  <Text fontSize="sm">
                                    {formatHour(
                                      item?.scheduled_initial_time,
                                      decodeToken.clinic.timezone
                                    )}
                                  </Text>
                                </Td>
                                <Td>
                                  <Text fontSize="sm">
                                    {formatHour(
                                      item?.scheduled_final_time,
                                      decodeToken.clinic.timezone
                                    )}
                                  </Text>
                                </Td>
                                {item?.edit_status === 3 || item?.status > 5 ? (
                                  <Td flexDir="row" textAlign="left">
                                    <Flex flexDirection="row" gap="2" textAlign="left">
                                      {item.status === 1 && (
                                        <Text fontSize="small" fontWeight="extrabold">
                                          {t('status.1')}
                                        </Text>
                                      )}
                                      {item.status === 2 && (
                                        <Text
                                          fontWeight="extrabold"
                                          color="blue.300"
                                          fontSize="small"
                                        >
                                          {t('status.2')}
                                        </Text>
                                      )}
                                      {item.status === 3 && (
                                        <Text
                                          fontWeight="extrabold"
                                          color="orange.500"
                                          fontSize="small"
                                        >
                                          {t('status.3')}
                                        </Text>
                                      )}
                                      {item.status === 4 && (
                                        <Text
                                          fontWeight="extrabold"
                                          color="red.500"
                                          fontSize="small"
                                        >
                                          {t('status.4')}
                                        </Text>
                                      )}
                                      {item.status === 5 && (
                                        <Text
                                          fontWeight="extrabold"
                                          color="blue.900"
                                          fontSize="small"
                                        >
                                          {t('status.5')}
                                        </Text>
                                      )}
                                      {item.status === 6 && (
                                        <Text
                                          fontWeight="extrabold"
                                          color="green.300"
                                          fontSize="small"
                                        >
                                          {t('status.6')}
                                        </Text>
                                      )}
                                      {item.status === 7 && (
                                        <Text
                                          fontWeight="extrabold"
                                          color="green.600"
                                          fontSize="small"
                                        >
                                          {t('status.7')}
                                        </Text>
                                      )}
                                      {item?.status_by_system && (
                                        <Tooltip
                                          label={t('bySystem')}
                                          aria-label={t('bySystem')}
                                          hasArrow
                                          placement="auto-end"
                                        >
                                          <Box>
                                            <Flex
                                              rounded="full"
                                              w="14px"
                                              alignItems="center"
                                              justifyContent="center"
                                              h="14px"
                                              bg="blue.300"
                                              color="white"
                                            >
                                              <Text fontSize="8px">S</Text>
                                            </Flex>
                                          </Box>
                                        </Tooltip>
                                      )}
                                    </Flex>
                                  </Td>
                                ) : (
                                  <Td flexDir="row">
                                    <Flex
                                      justifyContent="flex-start"
                                      alignItems="center"
                                      flexDirection="row"
                                      gap="2px"
                                    >
                                      <Box w="128px">
                                        <Select
                                          size="xs"
                                          my="0"
                                          name="status"
                                          color={returnColorStatusByView(item?.status)}
                                          fontWeight="bold"
                                          options={
                                            item?.edit_status === 1
                                              ? statusOptionsLimited
                                              : statusOptionsDefault
                                          }
                                          value={item.status}
                                          onChange={(event) => {
                                            setStatus(Number(event.target.value))
                                            setSelectedScheduling(item)
                                          }}
                                        />
                                      </Box>
                                      {item?.status_by_system && (
                                        <Tooltip
                                          label={t('bySystem')}
                                          aria-label={t('bySystem')}
                                          hasArrow
                                          placement="auto-end"
                                        >
                                          <Box>
                                            <Flex
                                              rounded="full"
                                              w="14px"
                                              alignItems="center"
                                              justifyContent="center"
                                              h="14px"
                                              bg="blue.300"
                                              color="white"
                                            >
                                              <Text fontSize="8px">S</Text>
                                            </Flex>
                                          </Box>
                                        </Tooltip>
                                      )}
                                    </Flex>
                                  </Td>
                                )}
                                <Td w="400px" alignItems="start" justifyContent="left" gap="8px">
                                  <Flex
                                    w="100%"
                                    flexDir="row"
                                    alignItems="center"
                                    justifyContent="left"
                                    gap="8px"
                                  >
                                    <Box>
                                      <PatientAvatarPreview
                                        src={item?.patient_image}
                                        name={item?.patient_name || 'Paciente'}
                                      />
                                    </Box>
                                    <Tooltip
                                      label={item?.patient_social_name ?? item?.patient_name ?? ''}
                                      aria-label={
                                        item?.patient_social_name ?? item?.patient_name ?? ''
                                      }
                                      hasArrow
                                      placement="top-start"
                                    >
                                      <Link
                                        to={{
                                          pathname: `/clients/update/${item.patient_id}`,
                                          state: {
                                            backContext: {
                                              source: 'scheduling',
                                              label: 'Voltar para agendamentos',
                                              description: 'Você retornará para agendamentos',
                                              path: `/scheduling`
                                            }
                                          }
                                        }}
                                        onClick={() => {
                                          setTabIndexClient(1)
                                        }}
                                      >
                                        <Text
                                          noOfLines={1}
                                          fontSize="xs"
                                          _hover={{
                                            textDecoration: 'underline'
                                          }}
                                        >
                                          {item?.patient_name ?? item?.patient_social_name}
                                        </Text>
                                        <Text color="gray.500" fontSize="xs" fontStyle="italic">
                                          {item?.patient_social_name
                                            ? `(${item?.patient_social_name})`
                                            : ''}
                                        </Text>
                                      </Link>
                                    </Tooltip>
                                  </Flex>
                                </Td>
                                {specialistIds.length === 1 ? null : (
                                  <Td>
                                    <Text fontSize="smaller">{item.specialist_name}</Text>
                                  </Td>
                                )}
                                <Td w="230px">
                                  {item?.attendance_items?.map((service) => (
                                    <ServiceProtocolTooltip
                                      key={service.id}
                                      serviceId={service.service_id}
                                      title={`${service?.service_name} - 1/${service?.total_session}`}
                                    >
                                      <Text
                                        noOfLines={1}
                                        fontSize="12px"
                                        fontWeight="semibold"
                                        _hover={{ cursor: 'default' }}
                                      >
                                        {`${service?.service_name} - 1/${service?.total_session}`}
                                      </Text>
                                    </ServiceProtocolTooltip>
                                  ))}

                                  {item?.sessions?.map((sec) => (
                                    <ServiceProtocolTooltip
                                      key={sec.id}
                                      serviceId={sec.service_id}
                                      title={`${sec?.service_name} - ${sec?.session_number}/${sec?.total_session}`}
                                    >
                                      <Text
                                        noOfLines={1}
                                        fontSize="12px"
                                        fontWeight="semibold"
                                        _hover={{ cursor: 'default' }}
                                      >
                                        {`${sec?.service_name} - ${sec?.session_number}/${sec?.total_session}`}
                                      </Text>
                                    </ServiceProtocolTooltip>
                                  ))}
                                </Td>
                                <Td>
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                  >
                                    <Tooltip
                                      label={
                                        <InfoTooltipCard
                                          created_at={(item as any)?.created_at}
                                          updated_at={(item as any)?.updated_at}
                                          created_by={(item as any)?.created_by}
                                          updated_by={(item as any)?.updated_by}
                                        />
                                      }
                                      aria-label="info"
                                      hasArrow
                                      placement="auto-end"
                                    >
                                      <Box>
                                        <FiUser size={16} color="#9699B0" />
                                      </Box>
                                    </Tooltip>
                                    {item?.observation ? (
                                      <Tooltip
                                        label={item?.observation ?? ''}
                                        aria-label={item?.observation ?? ''}
                                        hasArrow
                                        placement="auto-end"
                                      >
                                        <Box>
                                          <FcInfo size={16} />
                                        </Box>
                                      </Tooltip>
                                    ) : (
                                      <Box w="20px" />
                                    )}
                                    {item.block_guide ? (
                                      <Tooltip
                                        label={t('block')}
                                        aria-label={t('block')}
                                        hasArrow
                                        placement="top-start"
                                      >
                                        <Box>
                                          <AiFillLock size={16} color="red" />
                                        </Box>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip
                                        label={t('noBlock')}
                                        aria-label={t('noBlock')}
                                        hasArrow
                                        placement="top-start"
                                      >
                                        <Box>
                                          <AiFillUnlock size={16} color="green" />
                                        </Box>
                                      </Tooltip>
                                    )}
                                    {item?.notes?.length > 0 && (
                                      <PermissionComponent ipCode="VIEW" spiCode="NOTES">
                                        <Tooltip
                                          label={`Notas - ${item.notes.length}`}
                                          hasArrow
                                          placement="top-start"
                                        >
                                          <Flex
                                            alignItems="center"
                                            justifyContent="center"
                                            onClick={() => {
                                              setNotes(item.notes)
                                              setPatientName(item.patient_social_name || '')
                                              setPatientId(item.patient_id)
                                              setIsViewModalNote(true)
                                            }}
                                            cursor="pointer"
                                          >
                                            <MdSpeakerNotes size={16} color="#9699B0" />
                                            <Text
                                              ml="2px"
                                              p="2px"
                                              px="3px"
                                              bgColor="blue.300"
                                              color="white"
                                              rounded="full"
                                              fontSize="xs"
                                            >
                                              {item.notes.length}{' '}
                                            </Text>
                                          </Flex>
                                        </Tooltip>
                                      </PermissionComponent>
                                    )}
                                    {item?.patient_allow_note && (
                                      <Tooltip
                                        label={`Não recebe mais lembretes`}
                                        hasArrow
                                        placement="top-start"
                                      >
                                        <Flex
                                          alignItems="center"
                                          justifyContent="center"
                                          cursor="pointer"
                                        >
                                          <MdSpeakerNotesOff size={16} color="#ff0000" />
                                        </Flex>
                                      </Tooltip>
                                    )}
                                  </Stack>
                                </Td>

                                <Td>
                                  <Flex gap={2} flexDir="row">
                                    <Link
                                      to={{
                                        pathname: `/scheduling/update/${item.id}`,
                                        state: item
                                      }}
                                    >
                                      <Tooltip
                                        label="Editar"
                                        aria-label="editar"
                                        hasArrow
                                        placement="top-start"
                                      >
                                        <Box w="24px">
                                          <FiEdit
                                            color="#9699B0"
                                            size={16}
                                            style={{ cursor: 'pointer' }}
                                          />
                                        </Box>
                                      </Tooltip>
                                    </Link>
                                    {!item?.block_checkout && (
                                      <Link
                                        to={{
                                          pathname: `/financial/checkout/${item.id}`,
                                          state: item
                                        }}
                                      >
                                        {returnJsxElementStatusTicket(item?.ticket_status_payment)}
                                      </Link>
                                    )}
                                    {item?.patient_number && (
                                      <Flex gap={2}>
                                        <Icon
                                          as={AiOutlineWhatsApp}
                                          _hover={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            handleOpenDialogWhatsApp(item)
                                          }}
                                        />
                                        <Icon
                                          as={CheckIcon}
                                          color="green.500"
                                          _hover={{ cursor: 'pointer' }}
                                          onClick={() => {
                                            handleOpenDialogWhatsAppConfirm(item)
                                          }}
                                        />
                                        {/* <Icon
                                        as={AiOutlineWhatsApp}
                                        _hover={{ cursor: 'pointer' }}
                                        color="red"
                                        onClick={() => {
                                          handleOpenDialogWhatsAppCancel(item)
                                        }}
                                      /> */}
                                      </Flex>
                                    )}
                                  </Flex>
                                </Td>
                              </Tr>
                            )
                          }
                          if (timelineItem.type === 'block') {
                            const block = timelineItem.data as BlocksData

                            return (
                              <Tr key={`block-${block.id}`} bg="red.50">
                                <Td>
                                  <Flex align="center" gap={2}>
                                    <Text fontSize="sm" fontWeight="bold" color="red.700">
                                      BLOQ
                                    </Text>
                                  </Flex>
                                </Td>

                                <Td>
                                  <Text fontSize="sm">--</Text>
                                </Td>

                                <Td>
                                  <Text fontSize="sm">--</Text>
                                </Td>

                                <Td>
                                  <Text fontSize="sm">{formatBlockTimeRange(block, 'start')}</Text>
                                </Td>

                                <Td>
                                  <Text fontSize="sm">{formatBlockTimeRange(block, 'finish')}</Text>
                                </Td>

                                <Td>
                                  <Text fontSize="sm">--</Text>
                                </Td>

                                <Td>
                                  <Text fontSize="12px">{block.name || 'Bloqueio'}</Text>
                                </Td>

                                {specialistIds.length === 1 ? null : (
                                  <Td>
                                    <Text fontSize="smaller">{formatBlockSpecialists(block)}</Text>
                                  </Td>
                                )}

                                <Td w="230px">
                                  <Text fontSize="12px" fontWeight="semibold">
                                    {block.is_recurrent
                                      ? 'BLOQUEIO RECORRENTE'
                                      : 'BLOQUEIO PONTUAL'}
                                  </Text>
                                </Td>

                                <Td alignContent="flex-end">
                                  <Text>--</Text>
                                </Td>

                                <Td>
                                  <PermissionComponent ipCode="VIEW" spiCode="CALENDAR_BLOCKING">
                                    <Tooltip label="Visualizar" hasArrow placement="top-start">
                                      <Box
                                        w="24px"
                                        onClick={() => {
                                          setSelectedBlock(block)
                                          setIsViewBlockModal(true)
                                        }}
                                      >
                                        <FiEye
                                          color="#9699B0"
                                          size={16}
                                          style={{ cursor: 'pointer' }}
                                        />
                                      </Box>
                                    </Tooltip>
                                  </PermissionComponent>
                                </Td>
                              </Tr>
                            )
                          }
                          return null
                        })}
                      </>
                    )}
                  </Tbody>
                </Table>
                {mergedData.length === 0 && !isLoading && <NotFound />}

                {!(mergedData.length === 0 && !isLoading) && (
                  <Pagination
                    totalCountOfRegisters={getSchedulingData?.totalCountOfPage ?? 0}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                  />
                )}
              </Box>
              <NotesModal
                isOpen={isViewModalNote}
                onClose={() => setIsViewModalNote(false)}
                notes={notes}
                setNotes={setNotes}
                patientName={patientName}
                patientId={patientId}
              />
              <BlockTimesModal
                isOpen={isViewBlockModal}
                onClose={() => setIsViewBlockModal(false)}
                block={selectedBlock}
                specialistOptions={services.specialists.map((specialist) => ({
                  id: specialist.user.id,
                  name: specialist.social_name ?? specialist.user.name
                }))}
              />
            </>
          )}
          {frontendModel === 1 && (
            <Box>
              <ViewDayTimeline
                data={getSchedulingData?.scheduling}
                block={getSchedulingData?.blocks}
                initialDate={dateScheduling}
                setEndAt={setEndAt}
                setStartAt={setStartAt}
                specialistId={specialistIds.length === 1 ? specialistIds[0] : undefined}
              />
            </Box>
          )}
          <ModalArrivedTime
            isOpen={isOpen}
            onClose={handlerCloseModalArrivedTime}
            title={t('modalArrivedTime.title')}
            onUpdate={async () => {
              try {
                await handlerUpdateStatusAndArrivedTime(status, selectedScheduling)
                queryClient.invalidateQueries('scheduling')
                handlerCloseModalArrivedTime()
              } catch (error: any) {
                setIsChangeStatus(false)
              }
              setIsChangeStatus(true)
            }}
          >
            <Flex w="100%" align="center" justify="center" p="2">
              <TextFieldControlled
                name="ArrivedTime"
                mask="time"
                textAlign="left"
                placeholder="-- : --"
                initialValue={arrivedTime}
                label={t('modalArrivedTime.i1')}
                inputOnChange={(event) => setArrivedTime(event.currentTarget.value)}
              />
            </Flex>
          </ModalArrivedTime>
          <ModalConfirmExclude
            isOpen={isOpenExclude}
            onClose={() => setIsOpenExclude(false)}
            title="Deseja realmente mudar para esse status o agendamento?"
            onConfirmExclude={() => {
              handleChangeStatusCancelOrNotPresence(status, selectedScheduling)
            }}
          >
            <span>
              Ao clicar em confirmar esse agendamento será movido para o status{' '}
              {getStatusName(status)}.
            </span>
          </ModalConfirmExclude>
        </>
        <Flex w="100%" h="300px" />
      </LayoutList>
      <ModalArrivedTime
        notRenderFooter
        title="Mensagem para WhatsApp"
        isOpen={isOpenWhatsApp}
        onUpdate={() => {}}
        onClose={handleCloseModalWhatsApp}
      >
        <Stack w="100%" direction="column" p="2" alignItems="flex-end" justifyContent="flex-end">
          <Textarea
            placeholder="opcional"
            value={message}
            onChange={(event) => setMessage(event.currentTarget.value)}
          />
          <Box>
            <LinkChakra
              href={getWhatsAppUrl(numberWhatsApp, message)}
              target="_blank"
              rel="noreferrer"
              style={{
                textDecoration: 'none'
              }}
              onClick={() => handleCloseModalWhatsApp()}
            >
              <Button colorScheme="red">Enviar</Button>
            </LinkChakra>
          </Box>
        </Stack>
      </ModalArrivedTime>
    </>
  )
}
